import gettext from '@sdk/lang/gettext';
import MoreOptionsMenu from '@sdk/components/ui/MoreOptionsMenu';
import { MoreOptionsMenuOption } from '@sdk/components/ui/moreOptionsMenu.types';

const RESET_OPTION = 'reset';
const DELETE_OPTION = 'disable';

type Props = {
  openDeleteModal: (isPersonal: boolean) => void;
  onReset: (isPersonal: boolean) => void;
  isPersonal: boolean;
  iCalCreated: boolean;
};

const IcalOptionsMenu = ({ openDeleteModal, onReset, isPersonal, iCalCreated }: Props) => {
  const options: MoreOptionsMenuOption[] = [
    {
      key: RESET_OPTION,
      value: RESET_OPTION,
      label: gettext('Reset'),
      tooltipText: !iCalCreated ? gettext('No url to reset') : null,
      disabled: !iCalCreated,
    },
    {
      key: DELETE_OPTION,
      value: DELETE_OPTION,
      label: gettext('Disable'),
      tooltipText: !iCalCreated ? gettext('No url to disable') : null,
      disabled: !iCalCreated,
    },
  ];

  const optionClicked = (option: MoreOptionsMenuOption) => {
    if (option.value === RESET_OPTION) {
      onReset(isPersonal);
    } else if (option.value === DELETE_OPTION) {
      openDeleteModal(isPersonal);
    }
  };

  return (
    <>
      <MoreOptionsMenu buttonWidth={160} options={options} onClick={optionClicked} />
    </>
  );
};
export default IcalOptionsMenu;
